import type { CampaignAttributes } from "hooks/api/use-campaigns";

export const hasCampaignTemplateInstance = (
  campaign: Pick<CampaignAttributes, "strategyData" | "schemaVersion">,
): boolean => campaign.schemaVersion != null && campaign.strategyData != null;
